export default (payload) => ({
  type: 'UPDATE_CUSTOMERS_STATE',
  payload,
});
